import React, { useState, useEffect } from 'react';
import BaseModel from '../../BaseModal'
import { FlexWrapperCenter, LineView, GapView, FlexWrapper } from '../../styles/WrapperStyles';
import { InputText } from '../../styles/TextStyles';
import { BottomButton } from '../../styles/ButtonStyles';
import styled from 'styled-components';
import Loader from '../Loader';
import { getDate } from '../../utils';
import { ImageCirlceView } from '../../styles/ImageWrapper';
import urls from '../../api/urls.json';
import { authorizedHttpGet } from '../../api/httpCalls';

const ParentDiv = styled.div`
  width: auto;
  height: 339px;
  border-radius: 20px;
`;

const TextView = styled.p`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
`;

const InputStyle = styled(InputText)`
  width: 100px;
  height: 50px;
  border-radius: 10px;
`;

const GoButton = styled(BottomButton)`
  width: 50px;
  height: 50px;
  border-radius: 10px;
`;

const BottomButtonBelow = styled(BottomButton)`
  margin-top: 20px;
  margin-bottom: 20px;
`;

const LabelStatsModal = (props) => {

    const [breakdown, setBreakdown] = useState(['Male', 'Female', 'Male Approved', 'Female Approved', 'Male Disapproved', 'Female Disapproved']);
    const [countOfImages, setCountOfImages] = useState(null);

    useEffect(() => {
        // calculateTotalImagesForEachBreakdown()
    },[])

    const getKeyName = (label, item)=>{
        const [gender, profileStatus] = item.split(' ');
        const genderDowncase = gender?.toLowerCase();
        const profileStatusDowncase = profileStatus?.toLowerCase();
        const currentCountOfImages = profileStatus ? props.stats[label][`${genderDowncase}_${profileStatusDowncase}`] : props.stats[label][`${genderDowncase}`]
        const keyName= profileStatus ? `${gender} ${profileStatus}` : gender
        return [keyName, currentCountOfImages]
    }

    const calculateTotalImagesForEachBreakdown = ()=>{
        let totalImages = {}

        props.labels.forEach(label => {
            breakdown.forEach(item => {
                const [keyName, currentCountOfImages] = getKeyName(label, item)
                const total = totalImages[keyName] ? (totalImages[keyName] + currentCountOfImages) : currentCountOfImages
                totalImages = {...totalImages, [keyName]: total}
            })
        })

        setCountOfImages(totalImages)
    }

    return (
        <BaseModel closeModal={() => props.closeModal()}>
            <ParentDiv>
                <FlexWrapperCenter>
                    <div className='breakdownTable'>
                        <div className='labelsList '>
                        <h4>Label</h4>
                            <table>
                                <thead>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </thead>
                                <tbody>
                                    <tr><td></td></tr>
                                    <tr><td></td></tr>
                                    <tr><td></td></tr>
                                    <tr><td></td></tr>
                                    {
                                        props.labels.map((label, index) => {
                                            return <tr key={index}><td>{label}</td></tr>
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className='breakdownMale centerTextAline'>
                            <h4>Male</h4>
                            <table>
                                <thead>
                                    <th className='padding30px'>yes</th>
                                    <th className='padding30px'>neutral</th>
                                    <th className='padding30px'>no</th>
                                </thead>
                                <tbody>
                                    {
                                        props.labels.map((label, index) => {
                                            const maleStats = props.stats.male[label]
                                            return <tr>
                                                {['yes', 'neutral', 'no'].map((selection, index) =>{
                                                    return <td key={index}>{maleStats[selection]}</td>
                                                })
                                                }
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className='breakdownFemale centerTextAline'>
                            <h4>Female</h4>
                        <table>
                                <thead>
                                <th className='padding30px'>yes</th>
                                    <th className='padding30px'>neutral</th>
                                    <th className='padding30px'>no</th>
                                </thead>
                                <tbody>
                                    {
                                        props.labels.map((label, index) => {
                                            const maleStats = props.stats.female[label]
                                            return <tr className="padding30px">
                                                {['yes', 'neutral', 'no'].map((selection, index) =>{
                                                    return <td key={index}>{maleStats[selection]}</td>
                                                })
                                                }
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* <table>
                        <thead>
                            <th className='statsModalLabelHeader'>Label</th>
                            {breakdown.map((item, index) => {
                                return <th key={index} className='statsModalLabelHeaderCategory'>{item}</th>
                            })}
                        </thead>
                        <tbody>
                            <tr></tr>
                            <tr></tr>
                            <tr></tr>
                            <tr></tr>
                            <tr></tr>
                            <tr></tr>
                                {props.labels.map((label, index) => {
                                    return <tr>
                                        <td key={index}>{label}</td>
                                        {breakdown.map((item, index) => {
                                            const [keyName, currentCountOfImages] = getKeyName(label, item)
                                            return <td key={index} className='statsModalLabelHeaderCategory'>{currentCountOfImages}</td>
                                        })}
                                        </tr>
                                })}
                                <tr></tr>
                                <tr></tr>
                                <tr></tr>
                                <tr></tr>
                                <td>Total</td>
                                {
                                    countOfImages !== null && Object.keys(countOfImages).length === breakdown.length && breakdown.map((item, index) => {
                                        return <td key={index} className='statsModalLabelHeaderCategory'>{countOfImages[item]}</td>
                                    })
                                }
                        </tbody>
                    </table> */}
                </FlexWrapperCenter>
                <GapView height="20px" />
            </ParentDiv>
            <GapView height="20px" />
            <div>Total Images : {props.stats.total_images}</div>
        </BaseModel>
    );
};

export default LabelStatsModal;
